import React, { useRef } from 'react'
import styles from './Contact.module.css'
import { HoverState } from '../../../assets/utils/cursorTypes';
import IconComponent from '../../IconComponent/IconComponent';
import { MdEmail } from 'react-icons/md';
import { FaPhone } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import emailjs from '@emailjs/browser';

export type ContactProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
}


const Contact = (props: ContactProps) => {

    const handleMouseEnter = () => props.setHoverElement('pointer');
    const handleMouseLeave = () => props.setHoverElement('normal');
    const formContactRef = useRef<HTMLFormElement | null>(null);

    const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    
        if (!formContactRef.current) return;

        const form = formContactRef.current;
        const name = (form.elements.namedItem('name') as HTMLInputElement).value.trim();
        const email = (form.elements.namedItem('email') as HTMLInputElement).value.trim();
        const message = (form.elements.namedItem('message') as HTMLTextAreaElement).value.trim();

        if (!name || !email || !message) {
            alert("Please fill in all required fields.");
            return;
        }
    
        emailjs
            .sendForm(  
                process.env.REACT_APP_EMAILJS_SERVICE_ID!,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID!,
                formContactRef.current, {
                    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY!,
            })
            .then(
                () => {
                    window.location.reload();
                },
                (error) => {
                    console.log('FAILED...', error.text);
                },
            );
    };

    return (
        <div className={styles.container}>
            <div className={styles.contact_left}>
                <span className={styles.contact_desc}>Looking to start a project or you need consultation? Feel free to contact me.</span>
                <div className={styles.contacts_list}>
                    <div 
                        className={styles.contact_item}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span><IconComponent icon={MdEmail} size={22}/></span>
                        <span>jorgevieira1221@gmail.com</span>
                        <div className={styles.border_contact}></div>
                    </div>
                    <div 
                        className={styles.contact_item}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span><IconComponent icon={FaPhone} size={22}/></span>
                        <span>+351&nbsp;&nbsp;924458538</span>
                        <div className={styles.border_contact}></div>
                    </div>
                    <div 
                        className={styles.contact_item}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <span><IconComponent icon={FaLocationDot} size={22}/></span>
                        <span>Porto,&nbsp;&nbsp;Valongo</span>
                        <div className={styles.border_contact}></div>
                    </div>
                </div>
            </div>
            <div className={styles.contact_right}>
                <span className={styles.form_title}>Let's&nbsp;&nbsp;Talk</span>
                <form 
                    action="" 
                    className={styles.contact_form}
                    ref={formContactRef}
                    onSubmit={sendEmail}
                >
                    <input 
                        type="text" 
                        placeholder='Name*' 
                        name='name'
                        required
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    />
                    <input 
                        type="email" 
                        placeholder='Email*' 
                        name='email'
                        required
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    />
                    <textarea 
                        name="message" 
                        placeholder='Message*' 
                        id=""
                        required
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    ></textarea>
                    <button
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        type='submit'
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    )
}

export default Contact
